import { InjectionToken } from "@angular/core";
import { IRootScopeService } from "angular";

export enum AngularJsServiceUpgradeType {
    SMART_SERVICE_DELIVERY = 'SmartServiceDelivery',
    ROOT_SCOPE = '$rootScope',
    STATE = '$state',
  }

export const ANGULARJS_SERVICE_UPGRADE_TOKENS = {
    ROOT_SCOPE_TOKEN: new InjectionToken<IRootScopeService>(AngularJsServiceUpgradeType.ROOT_SCOPE),
    STATE_TOKEN: new InjectionToken<IRootScopeService>(AngularJsServiceUpgradeType.STATE),
    SMART_SERVICE_DELIVERY_TOKEN: new InjectionToken(AngularJsServiceUpgradeType.SMART_SERVICE_DELIVERY)
}